'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.week;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/week.js
// module id = 212
// module chunks = 0